import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
import InfoIcon from '@mui/icons-material/Info';
import HelpIcon from '@mui/icons-material/Help';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { Box, IconButton } from '@mui/material';
import Grid from "@mui/material/Grid2";
import MarkDown from 'react-markdown';

const levels = {
    'info': <InfoIcon sx={{ verticalAlign: 'text-bottom' }} />,
    'help': <HelpIcon sx={{ verticalAlign: 'text-bottom' }} />,
    'ai': <AutoAwesomeIcon sx={{ verticalAlign: 'text-bottom' }} />,
}


export default function InfoModal({
    open,
    content,
    callback,
    level = 'info',
    title = "Info",
    maxWidth = "sm",
    markdown = false,
}) {

    return (
        (<div>
            <Dialog
                open={open}
                onClose={() => callback && callback(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                maxWidth={maxWidth}
                fullWidth={true}
            >
                <DialogTitle>
                    <Grid container space={1} alignItems="center" sx={{ pr: 3 }}>
                        <Grid sx={{ pr: 1 }} size="auto">
                            {levels[level]}
                        </Grid>
                        <Grid size="auto">
                            <span>{title}</span>
                        </Grid>
                    </Grid>
                    <IconButton
                        aria-label="close"
                        onClick={() => callback && callback(false)}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{ pb: 1 }}>
                    <Box sx={{ minWidth: '300px' }}>
                        {markdown ? <MarkDown>{content}</MarkDown> :
                            content}
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Grid container justifyContent="space-between" sx={{ padding: "0px 10px 10px 10px" }} spacing={2}>
                        <Grid size="auto">
                        </Grid>
                        <Grid size="auto">
                            <Button variant="contained" onClick={() => callback && callback(true)}>
                                <CheckIcon /> <Box sx={{ pl: 1 }}><span>Ok</span></Box>
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
        </div>)
    );
}